// import dayjs from 'dayjs';
import * as qrCodeManage from '../services/qrCodeManage';

export default {
  namespace: 'qrCodeManage',

  state: {
    searchFormData: null,
    tableList: null,
    total: 0,
    hasNext: false,
    groupList: null,
    qrParamsFormData: [{ name: '', value: '' }],
    refreshQrParamsFormData: 0,
  },

  effects: {
    // 新增二维码-支持批量
    *batchAddQrCode({ payload, callback }, { call }) {
      const response = yield call(qrCodeManage.batchAddQrCode, payload);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 新增二维码组
    *addQrcodeGroup({ payload, callback }, { call }) {
      const response = yield call(qrCodeManage.addQrcodeGroup, payload);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 删除二维码分组
    *deleteQrcodeGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCodeManage.deleteQrcodeGroup, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },

    // 分页查询 二维码分组详情-列表
    *queryQrcodeGroupPage({ payload: { values }, callback }, { put, call }) {
      const response = yield call(qrCodeManage.queryQrcodeGroupPage, values);
      yield put({
        type: 'save',
        payload: {
          hasNext: response?.data.hasNext,
          total: response?.data.total,
          tableList: response?.data?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 编辑二维码名
    *updateQrcodeGroup({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCodeManage.updateQrcodeGroup, values);
      if (callback && typeof callback === 'function') {
        return callback(response?.code);
      }
    },

    // 二维码组-二维码下载
    *qrcodeGroupDownload({ payload: { values }, callback }, { call }) {
      const response = yield call(qrCodeManage.qrcodeGroupDownload, values);
      callback && callback(response);
    },

    // 公众号下没有分组的时候，直接重置数据不做查询
    *initQrCodeTableList({}, { put }) {
      yield put({
        type: 'save',
        payload: {
          total: 0,
          tableList: [],
        },
      });
    },
    // 点击添加一条二维码参数
    *operationParamData(
      {
        payload: {
          values: { index, status },
        },
      },
      { select, put },
    ) {
      const { qrParamsFormData } = yield select((state) => state.qrCodeManage);
      const qrParamsFormDataClone = [...qrParamsFormData];
      status === '1'
        ? qrParamsFormDataClone.splice(index + 1, 0, { name: '', value: '' })
        : qrParamsFormDataClone.splice(index, 1);
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
          refreshQrParamsFormData: 1,
        },
      });
    },
    *setParamData({ payload: { values } }, { put, select }) {
      const { index, value, key } = values;
      const { qrParamsFormData } = yield select((state) => state.qrCodeManage);
      const qrParamsFormDataClone = qrParamsFormData.map((item, i) => {
        if (index === i) {
          return key === 'name' ? { ...item, name: value } : { ...item, value };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: qrParamsFormDataClone,
        },
      });
    },
    // 清除参数的事件
    *clearOperationParamData({ payload: { values } }, { select, put }) {
      const { qrParamsFormData } = yield select((state) => state.qrCodeManage);
      const { key, index } = values;

      const newQrParamsFormData = qrParamsFormData.map((item, ind) => {
        if (index === ind) {
          return { ...item, [key]: '' };
        }
        return item;
      });
      yield put({
        type: 'save',
        payload: {
          qrParamsFormData: newQrParamsFormData,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname === '/system/qr_code_manage/add' ||
          props.pathname === '/system/qr_code_manage/add_qr'
        ) {
          dispatch({
            type: 'save',
            payload: {
              groupList: null,
              qrParamsFormData: [{ name: '', value: '' }],
              defaultFormData: null,
              autoReplyList: null,
              refreshQrParamsFormData: 0,
            },
          });
        }
      });
    },
  },
};
